/* ============================================================
   MY AGENT — DATA CONTOH (PROTOTAIP)
   ============================================================
   Data sahaja, tiada JSX. Ia berasingan daripada SenaraiAgentV39.jsx
   kerana peraturan lint `react-refresh/only-export-components`
   melarang satu fail mengeksport komponen DAN bukan-komponen
   serentak — corak yang sama seperti i18n/index.js lawan
   i18n/LangProvider.jsx.

   ⛔ CONTOH SAHAJA. Agent sebenar duduk dalam Firestore
      (`users/{uid}/chatgptTemplates`, penanda `agentV: 2`) dan
      dibaca oleh ProStudioAgentSection. Tiada satu pun nilai di
      sini menyentuh data pelanggan.
   ============================================================ */

/* ⛔ TIADA had bilangan agent (arahan user 2026-08-16). Had lama
   (`MAX_AGENTS = 5` dalam ProStudioAgentSection) dibuang kerana ia tidak
   pernah dikuatkuasakan oleh rules mahupun Cloud Functions, dan ia tidak
   mengikut pakej seperti setiap kuota lain. Nota penuh ada di kepala
   ProStudioAgentSection.jsx — baca dahulu sebelum memperkenalkannya
   semula di mana-mana. */

export const PRODUK_UJIAN = [
    'KOKOJAR BALANG BESAR BY CHOCOSUE 1400ML',
    'Serum Vitamin C 30ml',
    'Set Pinggan Mangkuk Melamine 12 Pcs',
];

/* Blok yang "dikesan" daripada jawapan agent. Dalam seksyen sebenar ia
   dikupas daripada tajuk-tajuk dalam jawapan; di sini ia dipaku supaya
   lakaran memapar bilangan yang SAMA seperti skrin sebenar (8 blok).
   Bilangan itu penting: baris cip 8 blok yang diulang di bawah setiap
   medan itulah punca utama aduan "serabut" 2026-08-19. */
export const SUMBER_CONTOH = [
    'set1', 'promptimage', 'hooktext', 'promptvideo',
    'videoscript', 'captiontiktok', 'set2', 'set3',
];

/* Nilai contoh setiap blok — dipakai oleh pratonton sahaja, supaya
   pratonton berubah hidup bila padanan diedit. `set1/2/3` ialah penanda
   struktur (tempat set bermula), bukan kandungan, jadi ia kosong.

   ⭐ SATU ENTRI SETIAP SET, dan ayatnya sengaja BERBEZA. Pratonton memapar
   set bersebelahan seperti kad produk sebenar; kalau ketiga-tiga lajur
   membawa ayat yang serupa, pelanggan membacanya sebagai lakaran rosak —
   dan dia terlepas perkara yang paling penting difahami, iaitu satu produk
   menghasilkan beberapa versi yang BERLAINAN. */
export const NILAI_SET = [
    {
        set1: '', set2: '', set3: '',
        hooktext: 'Sebalang ni boleh tahan sebulan?',
        promptimage: 'Close-up studio shot of a large chocolate spread jar on a marble counter, warm morning light, 9:16',
        videoscript: 'Kalau anak-anak memang suka coklat, balang besar ni berbaloi.',
        promptvideo: 'Slow push-in on the jar, a spoon lifts a thick swirl of chocolate',
        captiontiktok: 'Balang 1400ml, cukup untuk satu keluarga. #kokojar #chocosue',
    },
    {
        set1: '', set2: '', set3: '',
        hooktext: 'Harga sebalang ni buat aku terkejut.',
        promptimage: 'Top-down shot of the jar beside toast and sliced bananas on a wooden board, soft daylight, 9:16',
        videoscript: 'Sekali beli, boleh guna sampai raya. Aku dah kira balik harga per hidangan.',
        promptvideo: 'Hand spreads the chocolate across warm toast, steam rising, slow motion',
        captiontiktok: 'Kira balik harga per hidangan, memang berbaloi. #chocosue #kokojar',
    },
    {
        set1: '', set2: '', set3: '',
        hooktext: 'Anak aku minta setiap pagi.',
        promptimage: 'Kitchen counter scene, the jar in focus with a child’s breakfast plate blurred behind, 9:16',
        videoscript: 'Setiap pagi mesti minta. Senang, tak payah masak lama.',
        promptvideo: 'Camera tilts up from the plate to the jar, morning light through a window',
        captiontiktok: 'Sarapan lima minit, anak happy. #sarapanmudah #kokojar',
    },
];

/* Set 1 ialah nilai lalai bila pemanggil tidak menyatakan set. */
export const NILAI_BLOK = NILAI_SET[0];

/* Jawapan mentah contoh — diletak dalam laci "Tetapan lanjutan". */
export const JAWAPAN_CONTOH = `SET 1
HOOK TEXT: Sebalang ni boleh tahan sebulan?
IMAGE PROMPT — SCENE 1: Close-up studio shot of a large chocolate spread jar on a marble counter, warm morning light, 9:16
VIDEO PROMPT — SCENE 1: Slow push-in on the jar, a spoon lifts a thick swirl of chocolate
VIDEO SCRIPT: Kalau anak-anak memang suka coklat, balang besar ni berbaloi.
CAPTION TIKTOK: Balang 1400ml, cukup untuk satu keluarga. #kokojar #chocosue

SET 2
...`;

/* ⭐ LIMA MEDAN TETAP — turutan SAMA seperti lima kotak pada kad produk
   Workspace: Hook Text · Prompt Gambar · Video Script · Prompt Video ·
   Caption TikTok. Turutan itu bukan hiasan; ia turutan kerja sebenar
   (hook dahulu, gambar, skrip, video, kemudian caption), jadi pelanggan
   membaca senarai ini seperti dia membaca kadnya.

   ⛔ SATU senarai, TIADA kumpulan. Lakaran ini dulu memecahkannya kepada
   "Setiap babak" dan "Sekali setiap set" — user menolaknya 2026-08-19:
   "tak perlu, keliru". Kekerapan itu memang wujud di dalam enjin, tetapi
   ia sudah ditetapkan oleh jawapan Langkah 3 dan tiada apa yang pelanggan
   boleh buat mengenainya di sini.

   `enjin: true` = Flow membacanya terus untuk menjana gambar/video.
   Yang lain hanya dibawa ke kad produk untuk dibaca dan disalin.

   ⭐ `warna` = warna titik pada label, DISALIN daripada kad produk sebenar
   ([WorkspaceView.jsx](WorkspaceView.jsx) — Hook amber-500, Image Prompt
   blue-500, Video Script emerald-500, Video Prompt purple-500, Caption
   rose-500). Ia sengaja nilai tetap, bukan token: kad sebenar memakai
   warna Tailwind yang SAMA pada tema terang dan gelap, jadi pratonton yang
   memakai token akan berhenti kelihatan seperti kad yang ia tiru. */
const SEMUA_MEDAN = [
    { id: 'hook', kunci: 'prostudio.wizard.fieldHook', ikon: 'teks', warna: '#F59E0B' },
    { id: 'gambar', kunci: 'prostudio.wizard.fieldImage', ikon: 'gambar', enjin: true, tanda: 'prostudio.wizard.tagImage', warna: '#3B82F6' },
    { id: 'skrip', kunci: 'prostudio.wizard.fieldScript', ikon: 'teks', video: true, warna: '#10B981' },
    { id: 'video', kunci: 'prostudio.wizard.fieldVideo', ikon: 'video', enjin: true, tanda: 'prostudio.wizard.tagVideo', video: true, warna: '#A855F7' },
    { id: 'caption', kunci: 'prostudio.wizard.fieldCaption', ikon: 'teks', warna: '#F43F5E' },
];

/* Pilihan "gambar sahaja" di Langkah 3 menggugurkan Prompt Video — dan
   Video Script sekali, kerana skrip tanpa video tiada tempat untuk pergi. */
export const medanAgent = (d) => (d?.hasil === 'gambarvideo'
    ? SEMUA_MEDAN
    : SEMUA_MEDAN.filter((f) => !f.video));

/* Tajuk SEBENAR yang wujud dalam JAWAPAN_CONTOH. Berbeza daripada
   SUMBER_CONTOH (yang sudah berbentuk slug untuk palet) — enjin padanan
   memerlukan tajuk mentah supaya nilai berhenti pada tajuk berikutnya.
   Tanpa ini, pratonton blok buatan sendiri memanjang melepasi tajuk
   seterusnya dan kelihatan rosak. */
export const TAJUK_CONTOH = [
    'SET 1', 'SET 2',
    'HOOK TEXT:', 'IMAGE PROMPT — SCENE 1:', 'VIDEO PROMPT — SCENE 1:',
    'VIDEO SCRIPT:', 'CAPTION TIKTOK:',
];

/* Kod blok → TAJUK sebenar dalam jawapan. Palet memapar tajuk (nama yang
   pelanggan kenal), sementara kod kekal sama seperti yang dipakai templat
   medan dalam `dataKosong()` — kalau kedua-duanya tidak diselaraskan, cip
   palet menyisip kod yang tidak wujud dalam mana-mana templat dan setiap
   baris medan kelihatan 'tidak berpadan'. */
export const LABEL_CONTOH = {
    set1: 'SET 1',
    set2: 'SET 2',
    set3: 'SET 3',
    hooktext: 'HOOK TEXT:',
    promptimage: 'IMAGE PROMPT — SCENE 1:',
    promptvideo: 'VIDEO PROMPT — SCENE 1:',
    videoscript: 'VIDEO SCRIPT:',
    captiontiktok: 'CAPTION TIKTOK:',
};
export const dataKosong = () => ({
    nama: '', platform: 'chatgpt', url: '', arahan: '', balasan: 1,
    set: 3, babak: 4, hasil: 'gambarvideo', gambarProduk: 'setiap', avatar: 'tiada',
    produkUjian: '',
    /* Padanan awal — hasil "Configure". Kunci = id medan di atas. */
    padanan: {
        hook: '@hooktext',
        gambar: 'Hook: "@hooktext"\n@promptimage',
        skrip: '@videoscript',
        video: '@promptvideo\nDialog: "@videoscript"',
        caption: '@captiontiktok',
    },
});

/* Dua agent: satu siap, satu belum. Sengaja — baris "belum Configure"
   itulah yang paling perlu dinilai, kerana agent begitu TIDAK boleh
   dijalankan di Workspace (ia dikelabukan dalam pemilih agent). */
export const agentContoh = () => ([
    {
        id: 'a1', configured: true, tarikh: '5 Ogos 2026',
        data: {
            ...dataKosong(),
            nama: 'Agent Skincare Saya',
            url: 'https://chatgpt.com/g/g-6a23c02397-agent-skincare',
            set: 3, babak: 1, produkUjian: PRODUK_UJIAN[0],
        },
    },
    {
        id: 'a2', configured: false, tarikh: '',
        data: {
            ...dataKosong(),
            nama: 'Agent Barang Dapur',
            url: 'https://chatgpt.com/g/g-77bd11aa02-dapur',
            set: 2, babak: 4,
        },
    },
    /* Agent ketiga sengaja SIAP tetapi satu medan enjin tidak berpadan.
       Tanpa contoh begini, lakaran hanya memapar keadaan sempurna — dan
       keadaan "satu medan belum berpadan" itulah satu-satunya keadaan
       pada langkah ini yang benar-benar menuntut tindakan pelanggan. */
    {
        id: 'a3', configured: true, tarikh: '12 Ogos 2026',
        data: {
            ...dataKosong(),
            nama: 'Agent Fesyen Saya',
            url: 'https://chatgpt.com/g/g-91cc4471bd-fesyen',
            set: 2, babak: 2, produkUjian: PRODUK_UJIAN[2],
            padanan: { ...dataKosong().padanan, video: '' },
        },
    },
]);
